export default [
    // monthly installment table data
    {
        cash_equivalents: [
            {
                customer_asset_id: 3,
                customer_id: 3075,
                asset_type_id: 1,
                asset_type_name: 'cash_equivalents',
                asset_title: "saving account 1",
                customer_value: 250.00,
                admin_value: 3550.50,
                remark: '',
            },
            {
                customer_asset_id: 4,
                customer_id: 3075,
                asset_type_id: 1,
                asset_type_name: 'cash_equivalents',
                asset_title: "saving account 2",
                customer_value: 250.00,
                admin_value: 1250.50,
                remark: '',
            },
        ],
        investment_assets: [
            {
                customer_asset_id: 15,
                customer_id: 3075,
                asset_type_id: 2,
                asset_type_name: 'investment_assets',
                asset_title: "epf account 1",
                customer_value: 300.00,
                admin_value: 300.50,
                remark: '',
            },
            {
                customer_asset_id: 16,
                customer_id: 3075,
                asset_type_id: 2,
                asset_type_name: 'investment_assets',
                asset_title: "epf account 2",
                customer_value: 400.00,
                admin_value: 400.50,
                remark: '',
            },
            {
                customer_asset_id: 17,
                customer_id: 3075,
                asset_type_id: 2,
                asset_type_name: 'investment_assets',
                asset_title: "unit trust",
                customer_value: 400.00,
                admin_value: 400.50,
                remark: '',
            },
        ],
        personal_assets: [
            {
                customer_asset_id: 7,
                customer_id: 3075,
                asset_type_id: 3,
                asset_type_name: 'personal_assets',
                asset_title: "car loan",
                customer_value: 300.00,
                admin_value: 300.50,
                remark: '',
            },
            {
                customer_asset_id: 8,
                customer_id: 3075,
                asset_type_id: 3,
                asset_type_name: 'personal_assets',
                asset_title: "house loan",
                customer_value: 400.00,
                admin_value: 400.50,
                remark: '',
            },
        ],
        total: {
            total_asset: 0,
        }
    }
    
]